import { writeFileSync } from "fs";

import { CommandDefinition, OptionDefinition } from "./Commons/Options/CommandBasedOptionsParser";
import { buildFormsOptionsDefinition } from "./CLICommands/BuildForms/BuildFormsOptions";
import { devBuildCommandDefinition } from "./CLICommands/DevBuild/DevBuildOptions";
import { formStatsCommandDefinition } from "./CLICommands/FormStats/FormStatsOptions";
import { localizationCommandDefinition } from "./CLICommands/Localization/LocalizationOptions";
import { upgradeFormCommandDefinition } from "./CLICommands/UpgradeForm/UpgradeFormOptions";
import { initFormCommandDefinition } from "./CLICommands/InitForm/InitFormOptions";
import {
    buildServerCommandDefinition,
    devBuildServerCommandDefinition,
} from "./CLICommands/BuildServer/BuildServerServerOptions";

const commandDefs = [
    buildFormsOptionsDefinition,
    upgradeFormCommandDefinition,
    devBuildCommandDefinition,
    devBuildServerCommandDefinition,
    buildServerCommandDefinition,
    localizationCommandDefinition,
    initFormCommandDefinition,
    formStatsCommandDefinition,
];

function createOptionReadMe(x: OptionDefinition<unknown>): string {
    return `
* \`--${x.name}${x.alias ? ` (-${x.alias})` : ""}\`

  ${x.description}
`.trim();
}

function createCommandReadMe(x: CommandDefinition<unknown, string>): string {
    return `
## \`candy ${x.name}\`

${x.detailedDescription ? x.detailedDescription : x.description}

### Опции

${x.options.map(createOptionReadMe).join("\n\n")}

${x.examples ? "### Примеры использования" : ""}
${x.examples ? x.examples : ""}

${x.extendedDetails ? x.extendedDetails : ""}
`;
}

function createReadMe(): string {
    return `
# Candy Tools

## Перед началом работы

Все операции выполняются через запуск

\`\`\`
candy [имя-команды] [...опции]
\`\`\`

## Имена основных команд:
${commandDefs.map(x => `* \`${x.name}\``).join("\n")}

${commandDefs.map(createCommandReadMe).join("\n")}
    `.trim();
}

writeFileSync("README.md", createReadMe());
